import styled from 'styled-components';
import Colours from '/shared/styled/Colours';

export default styled.div`
  /* width: 10rem;
  height: 10rem;
  background: ${Colours.greyLight2};
  border-radius: 100%; */
  ul {
    padding: 1rem 0;
    line-height: 1;

    li {
      padding: 0;
      flex-direction: row;
      margin: 0;
      align-items: baseline;

      span, div {
        padding: 0.25rem 0 !important;
      }
    }
  }
`;
